import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNotification } from '../../contexts/NotificationContext';
import { Link } from 'react-router-dom';
import './Header.css';

function Header({ user }) {
  const { logout } = useAuth();
  const { showSuccess, showInfo } = useNotification();
  const [showDropdown, setShowDropdown] = useState(false);
  const [driverStatus, setDriverStatus] = useState('offline');
  const [statusLoading, setStatusLoading] = useState(false);

  useEffect(() => {
    // Load current status from API or localStorage
    const loadStatus = async () => {
      try {
    const token = localStorage.getItem('supertaxi_token') || localStorage.getItem('token');
    const response = await fetch('http://localhost:3002/api/auth/status', {
          headers: {
      'Authorization': token ? `Bearer ${token}` : ''
          }
        });

        const result = await response.json();
        
        if (result.success && result.data?.status) {
          setDriverStatus(result.data.status);
          localStorage.setItem('driverStatus', result.data.status);
        } else {
          // Fallback to localStorage
          const savedStatus = localStorage.getItem('driverStatus') || 'offline';
          setDriverStatus(savedStatus);
        }
      } catch (error) {
        console.error('Status loading error:', error);
        // Fallback to localStorage
        const savedStatus = localStorage.getItem('driverStatus') || 'offline';
        setDriverStatus(savedStatus);
      }
    };

    loadStatus();
  }, []);

  const handleLogout = () => {
    logout();
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const toggleStatus = async () => {
    setStatusLoading(true);
    try {
      const newStatus = driverStatus === 'online' ? 'offline' : 'online';
      
      // Send to backend API
      try {
    const token = localStorage.getItem('supertaxi_token') || localStorage.getItem('token');
    const response = await fetch('http://localhost:3002/api/auth/status', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
          },
          body: JSON.stringify({ status: newStatus })
        });

        const result = await response.json();
        
        if (result.success) {
          setDriverStatus(newStatus);
          localStorage.setItem('driverStatus', newStatus);
          
          // Show success notification
          if (newStatus === 'online') {
            showSuccess('Du bist jetzt online und für Fahrten verfügbar!', {
              title: '🟢 Online'
            });
          } else {
            showInfo('Du bist jetzt offline', {
              title: '🔴 Offline'
            });
          }
        } else {
          throw new Error(result.message || 'Status konnte nicht aktualisiert werden');
        }
      } catch (apiError) {
        console.error('API Status update error:', apiError);
        
        // Fallback to local storage
        localStorage.setItem('driverStatus', newStatus);
        setDriverStatus(newStatus);
        
        showInfo('Status lokal gespeichert (Offline-Modus)', {
          title: '⚠️ Offline-Modus'
        });
      }
      
    } catch (error) {
      console.error('Status update error:', error);
    } finally {
      setStatusLoading(false);
    }
  };

  const getStatusColor = () => {
    switch (driverStatus) {
      case 'online': return 'online';
      case 'busy': return 'busy';
      default: return 'offline';
    }
  };

  const getStatusText = () => {
    switch (driverStatus) {
      case 'online': return 'Online';
      case 'busy': return 'Beschäftigt';
      default: return 'Offline';
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1 className="header-logo">
            🚖 SuperTaxi
          </h1>
          <span className="header-subtitle">Taxifahrer Dashboard</span>
        </div>

        <div className="header-right">
          <div 
            className="header-status"
            onClick={toggleStatus}
            style={{ cursor: statusLoading ? 'wait' : 'pointer' }}
          >
            <span className={`status-indicator ${getStatusColor()}`}></span>
            <span className="status-text">
              {statusLoading ? 'Aktualisiere...' : getStatusText()}
            </span>
          </div>

          <div className="header-user" onClick={toggleDropdown}>
            <div className="user-avatar">
              {user?.firstName?.charAt(0) || 'T'}
            </div>
            <div className="user-info">
              <span className="user-name">
                {user?.firstName} {user?.lastName}
              </span>
              <span className="user-role">Taxifahrer</span>
            </div>
            <div className="dropdown-arrow">▼</div>

            {showDropdown && (
              <div className="user-dropdown">
                <Link to="/profile" className="dropdown-item" onClick={() => setShowDropdown(false)}>
                  <span>📊 Profil</span>
                </Link>
                <Link to="/settings" className="dropdown-item" onClick={() => setShowDropdown(false)}>
                  <span>⚙️ Einstellungen</span>
                </Link>
                <div className="dropdown-divider"></div>
                <div className="dropdown-item logout" onClick={handleLogout}>
                  <span>🚪 Abmelden</span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
